<template>
  <div>
    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <div class="card-body">
        <div class="text-right" v-if="!readonly">
          <form-button :indicator="indicator" @clicked="saveDates()">
            Save Dates
          </form-button>
        </div>
        <div class="clearfix"></div>
        <hr />

        <div>
          <div class="row">
            <div class="col-lg-6">
              <div class="widget widget-primary">
                <div class="widget-label">Days of Hire</div>
                <div class="widget-value">{{ totalHireDays }}</div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="widget widget-primary">
                <div class="widget-label">Total Hire Value</div>
                <div class="widget-value">
                  {{ totalHireValue | currency('£', false) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <table class="table">
          <thead>
            <tr>
              <th>Vehicle Registration</th>
              <th>Daily Rate</th>
              <th>Hire Start Date</th>
              <th>Requested Hire End Date</th>
              <th>Hire End Date</th>
              <th>Last Chargeable Date</th>
              <th>Hire Agreement Signed Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr :key="index" v-for="(hire, index) in hires">
              <td>
                {{
                  hire.vehicle?.vehicle?.registration ||
                    hire.vehicle?.registration ||
                    'Not Provided'
                }}
              </td>
              <td>{{ hire | dailyRate | currency('£', false) }}</td>
              <td>
                {{
                  hire.vehicle?.start_date
                    ? formatDate(hire.vehicle.start_date)
                    : 'Not Provided'
                }}
              </td>
              <td>
                <datepicker-input
                  v-model="hire.vehicle.requested_end_date"
                  :name="`requested_end_date_${index}`"
                ></datepicker-input>
              </td>
              <td>
                <datepicker-input
                  v-model="hire.vehicle.end_date"
                  :name="`end_date_${index}`"
                ></datepicker-input>
              </td>
              <td>
                <datepicker-input
                  v-model="hire.vehicle.last_chargeable_date"
                  :name="`last_chargeable_date_${index}`"
                ></datepicker-input>
              </td>
              <td>
                <datepicker-input
                  v-model="hire.vehicle.hire_agreement_signed_date"
                  :name="`last_chargeable_date_${index}`"
                ></datepicker-input>
              </td>
              <td>
                <form-button
                  level="warning"
                  :indicator="hvcIndicators[index]"
                  :disabled="!!hire.collection_job_id || hvcRequested[index]"
                  v-on:clicked="requestHireVehicleCollection(hire.id, index)"
                  v-if="!readonly"
                >
                  {{
                    hire.collection_job_id || hvcRequested[index]
                      ? 'Hire Vehicle Collection Requested'
                      : 'Request Hire Vehicle Collection'
                  }}
                </form-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-footer text-right" v-if="!readonly">
        <form-button :indicator="indicator" @clicked="saveDates()">
          Save Dates
        </form-button>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    client: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    hires() {
      return (this.$store.getters['Incident/creditHires'] || []).filter(
        hire => {
          return !!hire.vehicle?.start_date;
        }
      );
    },

    totalHireValue() {
      return this.hires.reduce((total, hire) => {
        return total + this.getHireTotal(hire);
      }, 0);
    },

    totalHireDays() {
      return this.hires.reduce((total, hire) => {
        return total + this.hireDays(hire);
      }, 0);
    },

    jobTypes() {
      return this.$store.getters['JobTypes/all'];
    }
  },

  data() {
    return {
      indicator: false,
      hvcRequested: {},
      hvcIndicators: {},
      form: new window.Form({
        vehicle_hire_agreement_sent: null,
        vehicle_hire_agreement_received: null,
        end_date: null,
        hire_agreement_signed_date: null
      })
    };
  },

  filters: {
    dailyRate(hire) {
      const rate = hire.vehicle?.rates?.find(
        rate => rate.charge?.name === 'daily'
      );

      if (rate) {
        return rate.rate;
      }

      return 0;
    }
  },

  mounted() {
    this.$store.commit('Incident/retrieveHires', {
      incident: this.incident,
      client: this.client
    });

    this.$store.commit('JobTypes/retrieve');
  },

  methods: {
    saveDates() {
      if (this.readonly) return;
      this.indicator = true;

      Promise.all(
        this.hires
          .filter(hire => !!hire.vehicle)
          .map(hire =>
            window.Ajax.put(
              `/hires/${hire.identifier}/vehicles/${hire.vehicle?.identifier}`,
              {
                ...hire?.vehicle,
                start_date: hire.vehicle?.start_date
                  ? window.DateManager.format(
                      hire.vehicle.start_date,
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  : null,
                end_date: hire.vehicle?.end_date
                  ? window.DateManager.format(
                      hire.vehicle.end_date,
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  : null,
                requested_end_date: hire.vehicle?.requested_end_date
                  ? window.DateManager.format(
                      hire.vehicle.requested_end_date,
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  : null,
                last_chargeable_date: hire.vehicle?.last_chargeable_date
                  ? window.DateManager.format(
                      hire.vehicle.last_chargeable_date,
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  : null,
                hire_agreement_signed_date: hire.vehicle
                  ?.hire_agreement_signed_date
                  ? window.DateManager.format(
                      hire.vehicle.hire_agreement_signed_date,
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  : null
              }
            )
          )
      ).then(() => {
        this.indicator = false;
        window.toastify.success('Saved!', 'The dates were saved successfully!');
      });
    },

    setEndDate(hire, date) {
      hire.vehicle.end_date = date;
    },

    formatDate(date) {
      return window.DateManager.format(date);
    },

    totalForChargeType(chargeType, hire) {
      return hire?.vehicle?.rates
        ?.filter(rate => rate.charge_type?.name === chargeType)
        .reduce((previous, rate) => previous + rate.rate, 0);
    },

    getTotalValue(hire) {
      if (hire && hire.vehicle) {
        if (!this.totalHireDays) {
          return '0.00';
        }

        const dailyRate = hire.vehicle.rates
          .filter(rate => rate.charge_type?.name === 'daily')
          .reduce((previous, rate) => {
            let value = rate.rate * this.totalHireDays;

            if (rate.max_rate && value > rate.max_rate) {
              value = rate.max_rate;
            }

            return previous + value;
          }, 0);

        return this.penceToPounds(
          this.totalForChargeType('one_off_fee', hire) + dailyRate
        );
      }

      return null;
    },

    getHireTotal(hire) {
      if (hire?.vehicle) {
        const days = this.hireDays(hire);

        if (days > 0) {
          const dailyRate = hire.vehicle.rates
            .filter(rate => rate.charge_type?.name === 'daily')
            .reduce((previous, rate) => {
              let value = rate.rate * days;

              if (rate.max_rate && value > rate.max_rate) {
                value = rate.max_rate;
              }

              return previous + value;
            }, 0);

          const oneOffFees = hire.vehicle.rates
            .filter(rate => rate.charge_type?.name === 'one_off_fee')
            .reduce((total, rate) => {
              return total + rate.rate;
            }, 0);

          return dailyRate + oneOffFees;
        }
      }

      return 0;
    },

    getDateRate(hire) {
      return {
        to: this.getStartDate(hire)
      };
    },

    getStartDate(hire) {
      return window.DateManager.parse(hire.vehicle?.start_date);
    },

    hireDays(hire) {
      if (hire?.vehicle?.start_date) {
        const hireEndDate = this.getHireEndDate(hire);
        const index = this.hires.indexOf(hire);
        let start = window.DateManager.parse(hire.vehicle.start_date);

        // If there is a previous hire we need to check if the previous
        // hire ended on the same day this hire started. If so we need
        // to add a day to the start date to ensure we don't charge
        // twice for the same day.
        if (index > 0) {
          const previousHire = this.hires[index - 1];

          const previousHireEndDate = this.getHireEndDate(previousHire);

          if (previousHireEndDate) {
            const previousEndDate = window.DateManager.parse(
              previousHireEndDate
            );

            if (
              window.DateManager.differenceInDays(previousEndDate, start) === 0
            ) {
              start = window.DateManager.addDay(start);
            }
          }
        }

        if (hireEndDate) {
          const endDate = window.DateManager.parse(hireEndDate);

          return window.DateManager.differenceInDays(endDate, start) + 1;
        }

        if (window.DateManager.isBefore(new Date(), start)) {
          return 0;
        }

        return window.DateManager.differenceInDays(new Date(), start) + 1;
      }

      return 0;
    },
    getHireEndDate(hire) {
      let endDate = hire?.vehicle?.last_chargeable_date;

      // if (this.isCrossHire(hire)) {
      //   endDate = hire.vehicle.last_chargeable_date
      // }

      return endDate;
    },
    isCrossHire(hire) {
      if (
        hire?.incident?.source?.incident_claim_type &&
        hire?.incident?.source?.incident_claim_type?.name === 'cross_hire'
      ) {
        return true;
      }

      return false;
    },
    setLastChargeableDate(hire) {
      if (!hire?.vehicle?.last_chargeable_date) {
        if (this.isCrossHire(hire)) {
          hire.vehicle.last_chargeable_date = hire.vehicle.requested_end_date;
        } else {
          hire.vehicle.last_chargeable_date = hire.vehicle.end_date;
        }
      }
    },
    requestHireVehicleCollection(hireId, index) {
      if (this.readonly) return;
      this.$set(this.hvcIndicators, index, true);

      let data = {
        hire_id: hireId,
        type_id: this.getJobTypeByName('hire_collection')?.id
      };

      window.Ajax.post(`/jobs/request`, data)
        .then(response => {
          this.$set(this.hvcIndicators, index, false);
          this.$set(this.hvcRequested, index, true);
        })
        .catch(error => {
          this.$set(this.hvcIndicators, index, true);
          window.toastify.error(
            'Error',
            'Sorry, there was an issue creating the job'
          );
        });
    },
    getJobTypeByName(name) {
      return this.jobTypes.find(type => type.name === name);
    }
  },
  watch: {
    hires: {
      handler(newHires) {
        // Watch for changes in hires and set last_chargeable_date
        newHires.forEach(hire => {
          this.setLastChargeableDate(hire);
        });
      },
      deep: true
    }
  }
};
</script>
